import { render, staticRenderFns } from "./logged.vue?vue&type=template&id=505c144c&scoped=true&"
import script from "./logged.vue?vue&type=script&lang=js&"
export * from "./logged.vue?vue&type=script&lang=js&"
import style0 from "./logged.vue?vue&type=style&index=0&id=505c144c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c144c",
  null
  
)

export default component.exports